module.exports = __webpack_public_path__ + "static/media/greenCheckmark.cdb5fdc6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/greenCheckmark.svg
// module id = 875
// module chunks = 21